import types from '../constants/types'

export const shareMutation = {
  [types.SHARE_STATUS] (state, aciton) {
    state['status'] = aciton.status
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/share.js